import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ShareholdingDetailsFormType } from '@app/modules/job/models/form/shareholder-form-type';
import { ShareDistributionFormType } from '@app/modules/share-distribution/models/form/share-distributions-form-type';
import {
  OfficerCompanyInput,
  OfficerPersonInput,
  ShareholdingDetailInput,
} from '@generated/graphql';

export abstract class AbstractOfficerForm {
  protected readonly formBuilder: FormBuilder;
  officerForm: FormGroup;
  shareDistributionForm: FormGroup<ShareDistributionFormType>;

  constructor() {
    this.formBuilder = new FormBuilder();
  }

  createShareDistributionsForm(): void {
    this.shareDistributionForm = this.formBuilder.group<ShareDistributionFormType>({
      shareDistributions: new FormArray<FormGroup<ShareholdingDetailsFormType>>(
        [],
      ),
    });
  }

  setShareDistribution(shareholding: ShareholdingDetailInput[]): void {
    const arrayControls = this.shareDistributionForm.controls.shareDistributions;
    arrayControls.clear();

    shareholding.forEach((s) =>
      arrayControls.push(
        this.formBuilder.group<ShareholdingDetailsFormType>({
          shareTypeId: this.formBuilder.control(s.shareTypeId ?? null),
          currency: this.formBuilder.control(s.currency ?? null),
          numberOfShares: this.formBuilder.control(s.numberOfShares ?? null),
        }),
      ),
    );
  }

  abstract createOfficerForm(): void;

  abstract setEditData(
    formData: OfficerCompanyInput | OfficerPersonInput,
    shareholding: ShareholdingDetailInput[],
  ): void;
}
